export var getNonStandardKey=function(e){return null==e.key&&null!=e.keyIdentifier?e.keyIdentifier:e.key};